var React = require('react');

function More (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-4.5 -14.625)"},[React.createElement("path",{"d":"M7.995,21.375a3.377,3.377,0,1,1,0-6.75,3.377,3.377,0,1,1,0,6.75Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M18,21.375A3.377,3.377,0,1,1,21.495,18,3.436,3.436,0,0,1,18,21.375Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M28,21.375A3.377,3.377,0,1,1,31.5,18,3.436,3.436,0,0,1,28,21.375Z","fill":"currentColor","key":2})]));
}

More.defaultProps = {"width":"27","height":"6.75","viewBox":"0 0 27 6.75"};

module.exports = More;

More.default = More;
